import { FC } from 'react'
import Link from 'next/link'
import { Row, Col, Text, List, ListItem, Content } from '@/client/components'
import * as S from './styles'
import { ShippingCostsProps } from '../types'

export const ShippingCosts: FC<ShippingCostsProps> = ({ shipping_options, description, relevant_links }) => (
  <Row>
    <Col>
      <S.Cards>
        {shipping_options.map(({ title, advantages }, index) => (
          <S.Card key={title} bgColor={index % 2 === 0 ? 'dark' : 'light'}>
            <Text size='lg' color='inverse' family='heading' weight='bold'>
              {title}
            </Text>
            <S.CardContent inverse content={advantages} />
          </S.Card>
        ))}
      </S.Cards>

      {description && <Content content={description} />}

      {relevant_links && (
        <>
          {relevant_links?.title && (
            <Text family='heading' size='lg' weight='bold' margin='2rem 0 1rem'>
              {relevant_links?.title}
            </Text>
          )}

          {relevant_links?.links && (
            <List kind='gold'>
              {relevant_links.links?.map(({ href, label }) => (
                <ListItem key={label}>
                  <Link href={href}>{label}</Link>
                </ListItem>
              ))}
            </List>
          )}
        </>
      )}
    </Col>
  </Row>
)
